export default "__VITE_ASSET__bNkq3nnb__"